var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('exchange-dashboard',{attrs:{"autoRefresh":true,"tableStats":_vm.stats,"graphStats":_vm.stats,"statBarStats":_vm.statBarStats,"table-fields":['bidder_name']}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ec71bfa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/exchange/pages/Dashboard.vue
// module id = null
// module chunks = 